import React from 'react';

export const NotAuthorized = () => {
    return (
        <h2>
            <center>
               You are not authorized to view this page.
            </center>
        </h2>
    );
};

export default NotAuthorized;
